import { Typography } from '@/components/atoms'
import { ThemeColor } from '@/enums'
import { Info } from '@/icons'
import { Tooltip } from '../Tooltip'
import { TooltipText } from './styles'
import { ReactNode } from 'react'
import { sizeMap } from '@/icons/helpers'

export interface InfoTooltipProps {
  content: ReactNode
  dark?: boolean
  iconColor?: ThemeColor
  size?: keyof typeof sizeMap
  text?: string | ReactNode
}

export const InfoTooltip = ({
  content,
  size,
  dark,
  iconColor = ThemeColor.b10,
  text,
}: InfoTooltipProps) => {
  if (!content) return null

  return (
    <Tooltip content={content} dark={dark}>
      <TooltipText alignItems="center" gap="4px">
        <Info color={iconColor} fill="none" size={size} stroke />
        {typeof text === 'string' ? (
          <Typography variant="captionR">{text}</Typography>
        ) : (
          text
        )}
      </TooltipText>
    </Tooltip>
  )
}
